import { BreadcrumbSkeleton } from '@/components/ui/breadcrumb-skeleton.component';
import { Card } from '@/components/ui/card.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';
import { EntityAboutLoading } from '@/app/(main)/(pages)/_components/entities/entity-about-loading.component';
import { EntityRatingCardLoading } from '@/app/(main)/(pages)/_components/entities/entity-rating-card-loading.component';
import { ProfessionalSchedulesLoading } from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/[slug]/_components/professional-schedules-loading.component';

export function ProfessionalProfileLoading() {
  return (
    <>
      <BreadcrumbSkeleton depth={2} />

      <ContentContainer className="px-0 sm:px-0 md:px-24 md:py-6">
        <div className="xl:grid xl:grid-cols-2 xl:items-start xl:gap-6">
          <section>
            <Card className="w-full rounded-none border-0 p-6 sm:px-16 md:rounded-xxl md:border md:p-6">
              <div className="flex flex-col items-center gap-4 pb-6 md:flex-row md:items-start">
                <Skeleton className="h-36 w-36 min-w-36" />

                <div className="flex w-full flex-col items-center gap-2 md:items-start">
                  <Skeleton className="h-9 w-11/12" />
                  <Skeleton className="h-5 w-40" />
                </div>
              </div>

              <Skeleton className="h-20 w-full rounded-xxl" />

              <EntityAboutLoading />

              <EntityRatingCardLoading />
            </Card>
          </section>

          <ProfessionalSchedulesLoading className="hidden xl:block" />
        </div>
      </ContentContainer>
    </>
  );
}
